import { withRoot } from '../constants';
import { getAsyncState } from '../reducers/async';

const mountSelector = state => state.ui.header;

export const getUserMenuExpanded = withRoot(mountSelector, state => state.userMenuExpanded);

export const getSearchAsyncState = withRoot(mountSelector, getAsyncState);
